import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router"
import { NotificationPopup } from "../common/notificationPopup/notificationPopup"
import { ButtonWhite } from "../common/buttonWhite/buttonWhite"
import {
  getDriversOnRoute,
  setSelectedDriver,
} from "../../features/driversOnRoute/driversOnRouteSlice"
import { setShowStations } from "../stations/stationsSlice"
import { getFormatedDate } from "../../utils/formatDate"
import "./driversOnRoute.scss"

export function DriversOnRoute() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { startDayTime, currentLanguage } = useSelector((state) => state.main)
  const { token } = useSelector((state) => state.loginOTP)
  const {
    getDriversOnRouteSuccess,
    getDriversOnRouteFailed,
    driversOnRouteList,
  } = useSelector((state) => state.driversOnRoute)

  useEffect(() => {
    dispatch(setShowStations(false))
    dispatch(getDriversOnRoute(token))
  }, [])

  useEffect(() => {
    if (getDriversOnRouteSuccess) {
    }
  }, [getDriversOnRouteSuccess])

  const handleDriverSelect = (driver) => {
    dispatch(setSelectedDriver(driver))
    navigate("/stationsManagerPage")
  }

  return (
    <div className="driversOnRoute-wrapper">
      <div className="driversOnRoute-container">
        <h1>נהגים בשטח</h1>
        <div className="driver-cards-container">
          {getDriversOnRouteSuccess &&
            driversOnRouteList.map((driver, index) => (
              <div
                key={index}
                className="driver-card"
                onClick={() => handleDriverSelect(driver)}
              >
                <div className="driver-header">
                  <div className="driver-name">{driver.driverName}</div>
                </div>
                <div className="driver-details">
                  <div>
                    <strong>מסלול:</strong> {driver.routeName}
                  </div>
                  <div>
                    <strong>זמן התחלה:</strong>{" "}
                    {getFormatedDate(driver.startDate)}
                  </div>
                  <div>
                    <strong>איסופים בהתחלה:</strong>{" "}
                    {driver.startPickupOrdersCount}
                  </div>
                  <div>
                    <strong>איסופים עדכון אחרון:</strong>{" "}
                    {driver.endPickupOrdersCount}
                  </div>
                  <div>
                    <strong>העמסות בהתחלה:</strong>{" "}
                    {driver.startReturnOrdersCount}
                  </div>
                  <div>
                    <strong>העמסות עדכון אחרון:</strong>{" "}
                    {driver.endReturnOrdersCount}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}
